import React, { useState, useEffect } from 'react';
import './Post.css';
import { db } from '../../config/firebase'; // Ensure the import path
import { doc, getDoc } from 'firebase/firestore';
import { BiUserCircle } from 'react-icons/bi';
import { useParams } from 'react-router-dom';

const Post = () => {
    const { id } = useParams(); // Get the post ID from the URL
    const [post, setPost] = useState(null);

    useEffect(() => {
        const fetchPost = async () => {
            if (id) {
                const docRef = doc(db, 'posts', id);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setPost(docSnap.data());
                } else {
                    console.log('No such document!');
                }
            }
        };

        fetchPost();
    }, [id]);

    if (!post) {
        return <div>Loading...</div>;
    }

    return (
        <div className='postbest'>
            <div className="postw">
                <img className='postImg2' src={post.imageUrl} alt={post.title} />
                <h1 className="title3">
                    {post.title}
                    <div className="edit">
                        <BiUserCircle className='icon' />
                    </div>
                </h1>
                <div className="info">
                    <span className="author">Author: <b>{post.author}</b></span>
                    <span className="date">{new Date(post.uploadedAt.seconds * 1000).toLocaleDateString()}</span>
                </div>
                <p className='describe7'>
                    {post.message}
                </p>
            </div>
        </div>
    );
}

export default Post;
